export default __webpack_public_path__ + "static/media/Wordpress_Disaster_Restoration_Services_Yonkers_NYArmor_Environmental_Solutions.c846f02d.png";